<template>
    <div class="filter-dialog">

         <div class="sort-div">  
             <p> Sort Work Orders </p>
            <el-dropdown trigger="click" @command="SortBy">
                <el-button type="primary" size="mini">
                {{ sortMode == "" ? "Sort by" : sortMode}}
                <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="Alphabetical">Alphabetical</el-dropdown-item>
                <el-dropdown-item command="Assignee">Assignee</el-dropdown-item>
                <el-dropdown-item command="Due Date">Due Date</el-dropdown-item>
                <el-dropdown-item command="Status">Status</el-dropdown-item>
                <el-dropdown-item command="Priority">Priority</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown> 
         </div>

         <div class="users-filters-parent">

           <div v-if="this.$route.fullPath.includes('UsersIssues')">

                <p class="inline-p"> Property Owner is </p>
                
                <el-dropdown trigger="click">

                    <el-button type="primary">
                        {{fullName('owner')}}  
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>

                    <el-dropdown-menu slot="dropdown">

                        <el-dropdown-item style="padding: 0px;">
                            <el-button style="width: 100%; border: none;" @click="usersForFiltering('All', 'owner')" >
                                All
                            </el-button>
                        </el-dropdown-item>
                    
                        <el-dropdown-item style="padding: 0px;" v-for="user in this.users"  :key="user.userid">
                            <el-button style="width: 100%; border: none;" @click="usersForFiltering(user, 'owner')">
                            {{user.firstname + " " + user.lastname}}
                            </el-button>
                        </el-dropdown-item>

                    </el-dropdown-menu>

                </el-dropdown>
            
            </div>
            
            <div>

                <p class="inline-p"> User Created is </p>
                
                <el-dropdown trigger="click">

                    <el-button type="primary">
                        {{fullName('created')}}  
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>

                    <el-dropdown-menu slot="dropdown">

                        <el-dropdown-item style="padding: 0px;">
                            <el-button style="width: 100%; border: none;" @click="usersForFiltering('All', 'created')" >
                                All
                            </el-button>
                        </el-dropdown-item>

                        <el-dropdown-item style="padding: 0px;" v-for="user in this.users"  :key="user.userid">
                            <el-button style="width: 100%; border: none;" @click="usersForFiltering(user, 'created')">
                            {{user.firstname + " " + user.lastname}}
                            </el-button>
                        </el-dropdown-item>

                    </el-dropdown-menu>

                </el-dropdown>

            </div>

            <div>

                <p class="inline-p"> User Assigned is </p>
                
                <el-dropdown trigger="click">

                    <el-button type="primary">
                        {{fullName('assigned')}}  
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>

                    <el-dropdown-menu slot="dropdown">

                        <el-dropdown-item style="padding: 0px;">
                            <el-button style="width: 100%; border: none;" @click="usersForFiltering('All', 'assigned')" >
                                All
                            </el-button>
                        </el-dropdown-item>

                        <el-dropdown-item style="padding: 0px;" v-for="user in this.users"  :key="user.userid">
                            <el-button style="width: 100%; border: none;" @click="usersForFiltering(user, 'assigned')">
                            {{user.firstname + " " + user.lastname}}
                            </el-button>
                        </el-dropdown-item>

                    </el-dropdown-menu>

                </el-dropdown>

            </div>
         
         </div>

         <div class="status-filters-parent">
             <p> Select status of Work Orders. </p>
             <input type="radio" id="everyStatus" v-model="issueStatus" name="status" value="All">
             <label for="everyStatus"> All </label><br>

             <input type="radio" id="open" v-model="issueStatus" name="status" value="open">
             <label for="open"> Open </label><br>
             
             <input type="radio" id="closed" v-model="issueStatus" name="status" value="closed">
             <label for="closed"> Closed </label><br>
             
             <!-- <input type="checkbox" id="overdue" v-model="issueStatus.overdue">
             <label for="overdue"> Overdue </label><br> -->

         </div>

         <div>
            <input type="checkbox" v-model="issuesCanComplete" id="can-complete"> 
            <label for="can-complete">Can be completed</label>
         </div>

         <el-button class="left-in-flex" @click="resetFilters()"> Reset Filters </el-button> 

         <el-button type="primary" style="margin-bottom: 20px;" @click="closeFormAndPassData"> Save filters </el-button>

    </div>
</template>

<script>

import EventService from "@/services/EventService.js";
import { mapState } from "vuex";

export default {

    props: {
       propertyid: String,
       users: Array
    },
  
  data(){
     return{
        sortMode:            "",
        selectedUsers:       {
                             owner:    "All",
                             created:  "All",
                             assigned: "All"
                             },
        issueStatus:         "All",
        issuesCanComplete: false
        }
   },

   methods: {

       SortBy(option) {
          this.sortMode = option;
        },

        fullName(usersRelation){

            switch(usersRelation){
               
                case "owner":

                    if(this.selectedUsers.owner.firstname != null)
                    {
                        return this.selectedUsers.owner.firstname + " " + this.selectedUsers.owner.lastname;
                    }
                    else
                    {
                        return this.selectedUsers.owner;
                    }
                break;
                
                case "created":

                    if(this.selectedUsers.created.firstname != null)
                    {
                        return this.selectedUsers.created.firstname + " " + this.selectedUsers.created.lastname;
                    }
                    else
                    {
                        return this.selectedUsers.created;
                    }                
                    break;

                case "assigned":

                    if(this.selectedUsers.assigned.firstname != null)
                    {
                        return this.selectedUsers.assigned.firstname + " " + this.selectedUsers.assigned.lastname;
                    }
                    else
                    {
                        return this.selectedUsers.assigned;
                    }               
                    break;
           }
        },

       usersForFiltering(user, usersRelation){

           switch(usersRelation){
               
                case "owner":
                  this.selectedUsers.owner = user;
                break;
                
                case "created":
                  this.selectedUsers.created = user;
                break;

                case "assigned":
                  this.selectedUsers.assigned = user;
                break;
           }

       },
    //    setAllStatus(){

    //        // loop through object to set all fields equal to the field "all"
    //        Object.keys(this.issueStatus).forEach( key => { this.issueStatus[key] = this.issueStatus.All });
    //    },
       closeFormAndPassData(){

           var filterCount = null;
           
           Object.keys(this.selectedUsers).forEach( key => { 
                if(this.selectedUsers[key] != "All"){
                    filterCount++;
                }
            });

           if(this.issueStatus != "All")
           { 
               filterCount++; 
           }

           if(this.issuesCanComplete == true){
               filterCount++;
           }

            var filters = {
                selectedUsers:     this.selectedUsers, 
                issueStatus:       this.issueStatus,
                sortMode:          this.sortMode,
                issuesCanComplete: this.issuesCanComplete,
                filterCount:       filterCount
            };

            this.$emit("submittedIssueFilters", filters)
        },
        resetFilters(){
           this.sortMode = "";

           this.selectedUsers = {
               owner: "All",
               created: "All",
               assigned: "All"
           };

           this.issueStatus = "All";

           this.issuesCanComplete = false;

           this.$emit("filtersReset")
        }
   },

  computed: {
    ...mapState({
      user: state => state.user.user
    })
  },

}
</script>

<style scoped>
  .filter-dialog{
        max-width: 700px;
        min-width: 800px;
        margin: auto;
        color: rgb(102, 102, 102);
        position: absolute;
        z-index: 10;
        background-color: white;
        max-width: 800px;
        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
        max-height: 75%;
        overflow-y: scroll;
        left: 50%;
        top: 40%;
        transform: translate(-50%,-50%);
        text-align: center;
    }
    
    .inline-p{
        display: inline-block;
        margin: 25px 20px;
    }

    .users-filters-parent, .status-filters-parent{
        display: table;
        text-align: left;
        margin: 35px auto;
    }

    .sort-div{
        margin: 20px 20px 0px;
    }
</style>